import React, { useState, useEffect, CSSProperties } from "react";
import { useDispatch } from "react-redux";
import h from "../../../helpers";
import BouncingDots from "../../loading/BouncingDots";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
interface IImportBulkLogDetail {
    id: number;
}

interface IImportBulkLogDetailArray {
    Id: number;
    CompanyId: number;
    FieldVisibilityTypeId: number;
    FieldVisibilityName: string;
    FieldId: number;
    OldValue: string;
    NewValue: number;
    CreatedBy: string;
    CreatedDate: string;
    LogId: number;
    Status: number;
}

const ImportBulkLogDetail: React.FC<IImportBulkLogDetail> = ({ id }: IImportBulkLogDetail) => {
    const dispatch = useDispatch();

    const [importBulkLogDetail, setImportBulkLogDetail] = useState<Array<IImportBulkLogDetailArray>>([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (id != null) {
            setIsLoading(true);
            const url = "/Field/ImportfieldlogDetailfor?" + h.serialize({ id });
            fetch(url, { method: "POST", credentials: "same-origin" })
                .then(h.checkStatus)
                .then(h.toJson)
                .then(data => {
                    const response = data as unknown as {
                        importBulkLogDetail: Array<IImportBulkLogDetailArray>;
                    };
                    setImportBulkLogDetail(response.importBulkLogDetail);
                    setIsLoading(false);
                });
        }
    }, [dispatch, id]);

    const tableHead: CSSProperties = {
        fontWeight: "bold",
        fontSize: 14,
        alignSelf: "center",
        fontFamily: "Roboto",
    };

    return (
        <div>
            <div>
                {isLoading && (
                    <div style={{ marginTop: "10px", textAlign: "center" }}>
                        <BouncingDots />
                    </div>
                )}
                {importBulkLogDetail != null && importBulkLogDetail.length > 0 && (
                    <TableContainer className="list-group" style={{ marginTop: 10, overflow: "auto", height: "55vh" }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center" style={tableHead}>
                                        ID
                                    </TableCell>
                                    <TableCell align="center" style={tableHead}>
                                        Status
                                    </TableCell>
                                    <TableCell align="center" style={tableHead}>
                                        Company ID
                                    </TableCell>
                                    <TableCell align="center" style={tableHead}>
                                        Field
                                    </TableCell>
                                    <TableCell align="center" style={tableHead}>
                                        Visibility
                                    </TableCell>
                                    <TableCell align="center" style={tableHead}>
                                        Old
                                    </TableCell>
                                    <TableCell align="center" style={tableHead}>
                                        New
                                    </TableCell>
                                    <TableCell align="center" style={tableHead}>
                                        Date
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {importBulkLogDetail.map(entry => (
                                    <TableRow key={entry.Id}>
                                        <TableCell style={{ fontSize: 12, width: 200 }} align="center">
                                            {entry.Id}
                                        </TableCell>
                                        <TableCell style={{ fontSize: 12, width: 200 }} align="center">
                                            {entry.Status == 1 ? (
                                                <span className="text-success">
                                                    <strong>Success</strong>
                                                </span>
                                            ) : (
                                                <span className="text-danger">
                                                    <strong>Error</strong>
                                                </span>
                                            )}
                                        </TableCell>
                                        <TableCell style={{ fontSize: 12, width: 200 }} align="center">
                                            {entry.CompanyId}
                                        </TableCell>
                                        <TableCell style={{ fontSize: 12, width: 200 }} align="center">
                                            {entry.FieldId}
                                        </TableCell>
                                        <TableCell style={{ fontSize: 12, width: 200 }} align="center">
                                            {entry.FieldVisibilityName}
                                        </TableCell>
                                        <TableCell style={{ fontSize: 12, width: 200 }} align="center">
                                            {entry.OldValue}
                                        </TableCell>
                                        <TableCell style={{ fontSize: 12, width: 200 }} align="center">
                                            {entry.NewValue}
                                        </TableCell>
                                        <TableCell style={{ fontSize: 12, width: 200 }} align="center">
                                            {entry.CreatedDate}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </div>
        </div>
    );
};

export default ImportBulkLogDetail;
